module.exports = __webpack_public_path__ + "static/img/8.db5a285.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/eng/8.png
// module id = kLzo
// module chunks = 0